// extracted by mini-css-extract-plugin
export default {"contents":"styles_contents__Gip-n","box":"styles_box__Ggv7i","social":"styles_social__Le3Et","icons":"styles_icons__KwKDA"};